import { autoUpdate, flip, FloatingPortal, offset, Placement, shift, size, useFloating } from "@floating-ui/react"
import clsx from "clsx"
import { ReactNode, useState } from "react"
import { AwayListener } from "./AwayListener"
import "./style.css"

export const Popover = ({
  target,
  children,
  placement = "bottom-start",
  onOpen,
  className,
}: {
  target: ReactNode
  children: (close: VoidFunction) => ReactNode
  placement?: Placement
  onOpen?: VoidFunction
  className?: string
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const { refs, floatingStyles } = useFloating({
    placement,
    onOpenChange: onOpen,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(5),
      flip({ padding: 10 }),
      shift(),
      size({
        apply({ availableHeight, rects, elements }) {
          Object.assign(elements.floating.style, {
            minWidth: `${rects.reference.width}px`,
            maxHeight: `${Math.max(0, availableHeight)}px`,
          })
        },
        padding: 10,
      }),
    ],
  })

  const close = () => setIsOpen(false)

  return (
    <AwayListener onAway={close}>
      <div
        onClick={() => {
          setIsOpen(!isOpen)
          onOpen?.()
        }}
        ref={refs.setReference}
      >
        {target}
      </div>
      {isOpen && (
        <FloatingPortal>
          <div
            onMouseDown={(e) => e.stopPropagation()}
            ref={refs.setFloating}
            className={clsx("popover-custom", className)}
            style={{ ...floatingStyles }}
          >
            {children(close)}
          </div>
        </FloatingPortal>
      )}
    </AwayListener>
  )
}
